import React from 'react';

import { NumberedPagination } from '../common/pagination/NumberedPagination';
import { UsersListItemLoading } from './UsersListItemLoading';
import { ListContainer } from '../common/ui/ListContainer';
import { UsersListHeader } from './UsersListHeader';
import { Component } from '../common/ui/Component';
import { EmptyCard } from '../common/ui/EmptyCard';
import { UsersListItem } from './UsersListItem';

export const UsersList = ({ isLoading, hasData, data, handlers, onReset }) => {
    if (isLoading) {
        return (
            <ListContainer>
                <UsersListHeader />
                <Component element={UsersListItemLoading} size={5} />
            </ListContainer>
        );
    }

    if (!hasData) {
        return (
            <ListContainer>
                <EmptyCard icon="icons" text="No results found">
                    <button type="button" className="btn btn-outline-primary" onClick={onReset}>
                        Clear filter
                    </button>
                </EmptyCard>
            </ListContainer>
        );
    }

    return (
        <ListContainer>
            <UsersListHeader />
            {data.records.map((user) => (
                <UsersListItem key={user.id} onRefresh={handlers.onRefresh} {...user} />
            ))}
            <NumberedPagination {...handlers} className="my-3" data={data} />
        </ListContainer>
    );
};
